import { Input, Typography } from '@weareopenr/component-library';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { channelsLogoHandler } from 'src/pages/Venue/channelsLogoHandler/channelsLogoHandler';
import { IFormValues } from 'src/components/VenueChannelsEditModal/types';
import { IAggregator } from 'src/types/aggregator.types';
import { IVenueCreateFormValues } from 'src/components/VenueCreateForm/types';
import ChannelLogo from 'src/components/ChannelLogo';
import styles from './VenueChannelsFields.module.scss';

interface IVenueChannelsFields {
  aggregators: IAggregator[];
  register: UseFormRegister<IFormValues | IVenueCreateFormValues>;
  errors: FieldErrors<IFormValues>;
}

const VenueChannelsFields = ({ aggregators, register, errors }: IVenueChannelsFields) => {
  return (
    <div className={styles['channels']}>
      {aggregators.map(({ aggregatorId, name }: IAggregator) => {
        const logo = channelsLogoHandler(name);
        return (
          <div key={aggregatorId} className={styles['channel-content']} data-cy={name}>
            <div className={styles['channel-logo-name']}>
              <ChannelLogo src={logo} alt={name} className={styles['logo']} />
              <Typography weight="semi-bold" className={styles['channel-name']}>
                {name}
              </Typography>
            </div>
            <div className={styles['channel-input']}>
              <Input
                type="text"
                label="Venue ID"
                register={register(`channels.${aggregatorId}.externalId`, {
                  validate: {
                    isRequired: (v: string, values: IFormValues) =>
                      !!v ||
                      (!v && !values.channels?.[aggregatorId]?.externalBrandId) ||
                      'Venue ID is required when External brand ID is provided',
                  },
                })}
                error={errors?.channels?.[aggregatorId]?.externalId?.message}
              />
            </div>
            <div className={styles['channel-input']}>
              <Input
                type="text"
                label="External brand ID"
                register={register(`channels.${aggregatorId}.externalBrandId`, {
                  deps: [`channels.${aggregatorId}.externalId`],
                })}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VenueChannelsFields;
